class ReviewsSlider extends HTMLElement {
  constructor() {
    super();
    this.flkty = null;
    this.el = null;
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    if (this.__flickityInit) return;
    this.__flickityInit = true;

    this.el = this.querySelector('[data-reviews-slider]');
    if (!this.el) return;

    this.flkty = new Flickity(
      this.el,
      JSON.parse(this.el.getAttribute('data-flickity') || '{}')
    );

    // Equalize heights after init
    this.flkty.on('ready', () => this.equalizeHeights());
    window.addEventListener('resize', this.handleResize);

    // Buttons
    this.querySelector('[data-rev-prev]')
      ?.addEventListener('click', () => this.flkty.previous());
    this.querySelector('[data-rev-next]')
      ?.addEventListener('click', () => this.flkty.next());

    // Run once on connect
    this.equalizeHeights();
  }

  handleResize() {
    requestAnimationFrame(() => {
      this.equalizeHeights();
      this.flkty.resize();
    });
  }

  equalizeHeights() {
    const cells = this.el.querySelectorAll('.pdp-reviews__cell');
    if (!cells.length) return;

    // reset first
    cells.forEach(cell => (cell.style.height = 'auto'));

    // find max height
    let maxHeight = 0;
    cells.forEach(cell => {
      maxHeight = Math.max(maxHeight, cell.offsetHeight);
    });

    // apply to all
    cells.forEach(cell => {
      cell.style.height = maxHeight + 'px';
    });

    // also set viewport so Flickity adapts correctly
    const viewport = this.el.querySelector('.flickity-viewport');
    if (viewport) {
      viewport.style.height = maxHeight + 'px';
    }
  }
}

customElements.define('reviews-slider', ReviewsSlider);
